export default __webpack_public_path__ + "static/media/icon_save.1d1168e7.svg";